import React, { useState, useLayoutEffect, useRef } from 'react';
import { useWindowWidth } from '@react-hook/window-size';
import defaultTheme from '../../tailwind.config';

export function useRefScrollProgress(inputRef) {
  const ref = inputRef || useRef();
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offsetTop = rect.top + scrollTop;
    setStart(offsetTop / document.body.clientHeight);
    setEnd((offsetTop + rect.height) / document.body.clientHeight);
  });
  return { ref, start, end };
}

export function useIsScreenSize(size = 'sm') {
  const width = parseInt(defaultTheme.theme.screens[size].replace('px', ''), 0);
  const viewport = useWindowWidth();
  return viewport <= width;
}
